import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { getCookie } from "../store/localStorage";
import { logoutRequest } from "../modules/login/services/LoginActions";

export function useJwtExpirationWatcher() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    useEffect(() => {
        const expirationTime = getCookie('jwtExpirationTime');
        if (!expirationTime) return;

        const expireAt = new Date(expirationTime).getTime(); // convert to ms
        const current = Date.now();
        const remaining = expireAt - current;
        console.log('session expires at', new Date(expirationTime), 'remaining time', remaining / 1000, 'seconds');

        if (remaining <= 0) { // Already expired
            handleExpire();
            return;
        }

        // handleExpire will be called after the remaining time
        const timer = setTimeout(() => handleExpire(), remaining);

        function handleExpire() {
            dispatch(logoutRequest());
        }

        return () => clearTimeout(timer);
    }, [navigate, dispatch]);
}
